<section class="container" *ngIf="authService.authState$ | async as auth">
  <div class="container-auth auth">
    <p class="auth-message">{{ auth?.message }}</p>

    <div class="auth-body d-flex justify-center align-center">
      <ng-container *ngIf="!auth.denied && !auth.error && !auth.loading">
        <app-svg-icon src="../../../../assets/icons/circle-check.svg "
                      color="accentGray"
                      width="75px"
                      height="65px">
        </app-svg-icon>
      </ng-container>

      <ng-container *ngIf="auth.denied || (auth.error && !auth.loading)">
        <app-svg-icon src="../../../../assets/icons/circle-check.svg "
                      color="accentGray"
                      width="75px"
                      height="65px">
        </app-svg-icon>
      </ng-container>

      <ng-container *ngIf="auth.loading">
        <mat-spinner diameter="60"></mat-spinner>
      </ng-container>
    </div>

    <div class="auth-actions actions d-flex">
      <button class="actions-btn"
              *ngIf="auth.denied === false"
              (click)="logout()">
        Sair
      </button>

      <button class="actions-btn"
              routerLink="/esteira-apuracao"
              *ngIf="!auth?.error">
        Início
      </button>

      <button class="actions-btn"
              *ngIf="auth?.error"
              (click)="tryLoginAgain()">
        Tentar novamente
      </button>
    </div>
  </div>
</section>
